import { clamp, isEqual } from 'lodash'
import { RefObject, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useEvent } from 'react-use'

import { setSidebarWidth } from 'redux/actions'
import { useRootStore } from 'stores/RootStore'
import { RootState } from 'types'

const SIDEBAR_MIN_WIDTH = 190
const SIDEBAR_MAX_WIDTH = 300

export function useSidebarResize(resizeHandleRef?: RefObject<HTMLDivElement>) {
  const dispatch = useDispatch()
  const savedSidebarWidth = useSelector(({ sidebarWidth }: RootState) => sidebarWidth, isEqual)
  const sidebarStore = useRootStore().leftSidebarStore

  useEffect(() => {
    sidebarStore.setResizingState({ sidebarWidth: savedSidebarWidth })
  }, [sidebarStore, savedSidebarWidth])

  const handleSidebarResizeStart = (e: React.MouseEvent) => {
    sidebarStore.setResizingState({
      startOffset: e.clientX,
      isResizing: true,
      initialWidth: savedSidebarWidth,
    })
  }

  useEvent('mousemove', (e: MouseEvent) => {
    if (!sidebarStore.isResizing) return

    sidebarStore.setResizingState({
      sidebarWidth: clamp(
        sidebarStore.initialWidth - (sidebarStore.startOffset - e.clientX),
        SIDEBAR_MIN_WIDTH,
        SIDEBAR_MAX_WIDTH,
      ),
    })
  })

  useEvent('mouseup', (e: MouseEvent) => {
    sidebarStore.setResizingState({ isResizing: false })

    // Finished dragging. Set sidebar width
    if (sidebarStore.sidebarWidth !== sidebarStore.initialWidth) {
      dispatch(setSidebarWidth(sidebarStore.sidebarWidth))
      return
    }
  })

  return { handleSidebarResizeStart, savedSidebarWidth }
}
